import React from "react";
import { Helmet } from "react-helmet";
import { ThemeProvider } from "styled-components";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AppContainer } from "./styles/global.style";
import theme from "./styles/theme";
import PublicRoutes from "./route";
import "./App.css";

toast.configure()

function App() {
  return (
    <AppContainer>
      <Helmet>
        <title>Understanding Houston</title>
      </Helmet>
      <ThemeProvider theme={theme}>
        <PublicRoutes />
      </ThemeProvider>
    </AppContainer>
  );
}

export default App;
